import React from "react";
import { Box } from "@chakra-ui/react";

export const P2pImageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<Box
			position={"relative"}
			backgroundColor={"#41474a"}
			overflowY={"auto"}
			width={"100%"}
			height={"100%"}
			display={"flex"}
			justifyContent={"center"}
			alignItems={"center"}
			maxHeight={"100%"}
		>
			{children}
		</Box>
	);
};
